import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const updateProfile = createAsyncThunk(
  "updateProfile/updateProfileUsers",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("KYC-details/profile-picture", payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const updateProfileSlice = createSlice({
  name: "updateProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default updateProfileSlice.reducer;
